// extracted by mini-css-extract-plugin
export var active = "_il-2";
export var recordingDot = "_il-1";
export var recordingIndicator = "_il-0";